import { UserDto } from './user.dto';
import { IsBoolean, IsOptional } from 'class-validator';
import { AcceptanceOptionsEnum } from '../../enums';
import { IEntityWithName } from "../../interfaces/entity-with-name.interface";

export class UserToFollowerDto {
	public id: string;
	public userId: string;
	public followerId: string;
	public acceptanceOptionId?: AcceptanceOptionsEnum;
	public acceptanceUpdatedAt?: Date;
	public isMutual: boolean;
	public user: UserDto;
	public follower: UserDto;
	public acceptanceOption?: IEntityWithName;
	public eventInstanceAcceptanceOptionId?: AcceptanceOptionsEnum;
	public createdAt?: Date;
	public updatedAt?: Date;
}

export class FollowingRequestAnswerDto {
	@IsBoolean()
	isAccepted: boolean;

	@IsOptional()
	@IsBoolean()
	ignoreNotifications?: boolean;
}

export class FollowRequestDto {
	@IsOptional()
	@IsBoolean()
	ignoreNotifications?: boolean;
}
